import axios from '@/plugins/axios';
import Vue from 'vue';
import Vuex from 'vuex';
import singleSubmission from './modules/single-submission';
import financeCompanies from './modules/finance-companies';
import account from './modules/account';
import submissions from './modules/submissions';
import users from './modules/users';
import products from './modules/products';
import discountCodes from './modules/discount-codes';
import config from '$root/config.js';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,

  state: {
    currentLenderCode: null,
    config: { ...config },
  },

  mutations: {
    setLenderCode(currentState, lenderCode) {
      currentState.currentLenderCode = lenderCode;
    },
    setConfig(currentState, payload) {
      currentState.config = { ...payload };
    },
  },

  actions: {
    updateConfigs({ commit, rootState }) {
      if (rootState?.account?.user != null) {
        axios.get('configs').then((resp) => {
          commit('setConfig', { ...config, ...resp.data });
        });
      } else {
        commit('setConfig', config);
      }
    },
  },

  getters: {
    config: (currentState) => currentState.config,
  },

  modules: {
    singleSubmission,
    financeCompanies,
    account,
    submissions,
    users,
    products,
    discountCodes,
  },
});
